
    import Vue from "vue";
    import MaterialCard from "@/views/base/MaterialCard.vue";
    import ActivityService from "../services/activity.service"
    import EditActivityForm from "./EditActivityForm.vue";
    import {eventBus} from "../services/event-bus";
    import Activity from "@/models/activity";

    export default Vue.extend({
        name: "ActivityList",
        components: {
            baseMaterialCard: MaterialCard,
            editActivityForm: EditActivityForm
        },
        methods: {
            loadActivities() {
                return ActivityService.activities().then(d => this.activities = d).catch(reason => eventBus.$emit('error', reason))
            },
            createActivity() {
                eventBus.$emit('create-activity')
            },
            refreshActivityList() {
                // eslint-disable-next-line no-console
                console.log("refresh activity list");
                //todo: odświeżyć bez zaciągania danych z bazy
                this.loadActivities()
                //this.forceRerender()
            },
            forceRerender() {
                this.componentKey += 1;
            }

        },
        data() {
            return {
                headers: [
                    {
                        text: 'Id',
                        value: 'id',
                    },
                    {
                        text: 'Color',
                        value: 'code',
                    },
                    {
                        text: 'Name',
                        value: 'name',
                    },
                    {
                        text: 'Description',
                        value: 'description',
                    },
                    {
                        text: 'Actions',
                        value: 'actions',
                    },
                ],
                actions: [
                    {
                        color: 'info',
                        icon: 'mdi-account-edit',
                        action: (item: any) => {
                            // eslint-disable-next-line no-console
                            console.log("row click edit-activity:" + item.id);
                            eventBus.$emit('edit-activity', item.id);
                        }
                    },
                    {
                        color: 'red',
                        icon: 'mdi-delete-forever',
                        action: (item: any) => {
                            // eslint-disable-next-line no-console
                            console.log("row click delete-activity:" + item.id);
                            eventBus.$emit('delete-activity', item.id);
                            //todo: dodanie obsługi kasowania
                        }
                    },
                ],
                activities: [] as Activity[],
                search: undefined,
                showForm: false,
                componentKey: 0,
            }
        },
        mounted(): void {
            this.loadActivities();
            eventBus.$on('refresh-activity-list', this.refreshActivityList)
        }
    })

